export default __webpack_public_path__ + "static/media/simpleinspect.3ee4cb0e.png";